// extracted by mini-css-extract-plugin
module.exports = {"container":"ContentLayout-module--container--2A202"};